import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';
import { NavbarLinkBadge } from '../NavbarLinkBadge';
import { LabelText } from '../Text';

type MainTabBarItemProps = {
  readonly testID?: string;
  readonly title: string;
  readonly accessibilityLabel?: string;
  readonly accessibilityHint?: string;
  readonly isActive: boolean;
  readonly hasBadge: boolean;
  readonly onPress: () => void;
  readonly onLongPress: () => void;
};

export const MainTabBarItem = ({
  testID,
  title,
  accessibilityLabel,
  accessibilityHint,
  isActive,
  hasBadge,
  onPress,
  onLongPress,
}: MainTabBarItemProps) => (
  <TouchableOpacity
    testID={testID}
    accessibilityLabel={accessibilityLabel ?? title}
    accessibilityHint={accessibilityHint}
    accessibilityRole="tab"
    accessibilityState={{ selected: isActive }}
    onPress={onPress}
    onLongPress={onLongPress}
    style={styles.container}
  >
    <LabelText
      size={2}
      style={[styles.label, isActive && styles.labelSelected]}
    >
      {title}
    </LabelText>
    {hasBadge ? (
      <NavbarLinkBadge badgeType="mobile" testID={testID?.concat('.badge')} />
    ) : null}
    <View
      testID={testID?.concat('.indicator')}
      style={[styles.indicator, isActive && styles.indicatorSelected]}
    />
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    alignItems: 'center',
  },
  label: {
    marginTop: 16,
    marginBottom: 6,
    paddingHorizontal: 8,
    color: theme.colors.NEUTRAL_2,
  },
  indicator: {
    width: 24,
    height: 1,
  },
  labelSelected: {
    color: theme.colors.GREEN_2,
  },
  indicatorSelected: {
    backgroundColor: theme.colors.GREEN_2,
  },
});
